<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lTfSKN/tc-custom/9781488076923.jpg?1730288461010" alt="This image is the cover for the book Christmas on Peach Tree Lane"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas on Peach Tree Lane
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: A Christmas-shop owner meets a handsome Scrooge in a novel by “the queen of small-town romance” (Maisey Yates, <i>New York Times</i>–bestselling author of <i>Hero for the Holidays</i>).</b><br/><br/>Event planner Violet Calhoun lives to deck the halls, and her quaint Southern hometown’s fiftieth annual Tinsel Tour will be the event of the season. With a magazine crew on hand to document Peach Grove’s transformation into a winter wonderland, this year’s festivities have got to be the holly-est, jolliest yet. So she does not have time to deal with a Grinch—even a gorgeous one like Brady Jackson . . . <br/><br/>Divorce attorney Brady has plans to divest himself of his family’s ancestral mansion and be back at his Atlanta firm by New Year’s. Hanging so much as a wreath on the door is not a part of that plan. Nor is dealing with an annoying—though undeniably adorable—elf. But Violet is all about making holiday magic happen. As they work together to stage Brady’s historic house, the town grump reveals he’s more sexy than Scrooge. And after some mind-blowing kisses, what starts as a Christmas flirtation starts to feel more like a year-round affair . . . <br/><br/><b>Praise for Jules Bennett’s novels</b><br/><br/>“Bennett has a gift for creating warm-hearted, emotional stories.” —JoAnn Ross, <i>New York Times</i>–bestselling author of <i>Forever in Honeymoon Harbor</i><br/><br/>“Convincing chemistry.” —<i>Publishers Weekly</i><br/><br/>“Heartwarming and passionate characters guaranteed to grip your heart.” —Lori Foster, <i>New York Times</i>–bestselling author of <i>Let Me Be the One</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jules Bennett
      </h2>
      
      <p class="authorDescription body article"><I>USA&#160;TODAY</I> Bestselling Author Jules Bennett has penned&#160;more than&#160;50 novels during her short career.&#160;She&#39;s married to her high school sweetheart, has two active girls, and is a former salon owner. Jules can be found on Twitter, Facebook (Fan Page), and her website julesbennett.com. She holds contests via these three outlets with each release and loves to hear from readers!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?95b837b4